var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.38,
    height: 107.3,
    viewBox: "0 0 146.38 107.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-out",
    transform: "translate(0 -0.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106126",
    "data-name": "Group 106126",
    transform: "translate(0 43.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106124",
    "data-name": "Group 106124",
    transform: "translate(3.983 6.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69800",
    "data-name": "Path 69800",
    d: "M136.307,303.946H55.934a3.255,3.255,0,0,1-3.234-3.234V248.968a1.668,1.668,0,1,1,3.336,0v51.676H136.2V248.968a1.668,1.668,0,1,1,3.336,0v51.778A3.2,3.2,0,0,1,136.307,303.946Z",
    transform: "translate(-52.7 -247.3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106125",
    "data-name": "Group 106125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69801",
    "data-name": "Path 69801",
    d: "M132.675,237.213H44.1a3.109,3.109,0,0,1-3.1-3.1V230.1a3.109,3.109,0,0,1,3.1-3.1h88.611a3.08,3.08,0,0,1,3.064,3.1v4.051A3.059,3.059,0,0,1,132.675,237.213Zm-88.339-3.3h88.135v-3.54H44.336Z",
    transform: "translate(-41 -227)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_106137",
    "data-name": "Group 106137",
    transform: "translate(4.221 0.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106130",
    "data-name": "Group 106130",
    transform: "translate(43.506 21.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106129",
    "data-name": "Group 106129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106128",
    "data-name": "Group 106128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106127",
    "data-name": "Group 106127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69802",
    "data-name": "Path 69802",
    d: "M222.391,186.738a1.671,1.671,0,0,1-1.668-1.668V173.155a8.906,8.906,0,0,0-8.919-8.919H193.455a8.906,8.906,0,0,0-8.919,8.919V185.07a1.668,1.668,0,0,1-3.336,0V173.155A12.269,12.269,0,0,1,193.455,160.9H211.77a12.269,12.269,0,0,1,12.255,12.255V185.07A1.664,1.664,0,0,1,222.391,186.738Z",
    transform: "translate(-181.2 -160.9)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_106133",
    "data-name": "Group 106133",
    transform: "translate(54.059 35.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106131",
    "data-name": "Group 106131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69803",
    "data-name": "Path 69803",
    d: "M213.868,215.034a1.671,1.671,0,0,1-1.668-1.668v-7.9a1.668,1.668,0,0,1,3.336,0v7.9A1.671,1.671,0,0,1,213.868,215.034Z",
    transform: "translate(-212.2 -203.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106132",
    "data-name": "Group 106132",
    transform: "translate(18.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69804",
    "data-name": "Path 69804",
    d: "M267.868,215.034a1.671,1.671,0,0,1-1.668-1.668v-7.9a1.668,1.668,0,0,1,3.336,0v7.9A1.671,1.671,0,0,1,267.868,215.034Z",
    transform: "translate(-266.2 -203.8)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_106134",
    "data-name": "Group 106134",
    transform: "translate(0 14.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69805",
    "data-name": "Path 69805",
    d: "M87.544,165.9h-12.9a1.668,1.668,0,1,1,0-3.336H86.965V143.5H56.736v19.063H69.059a1.668,1.668,0,1,1,0,3.336H56.191A2.8,2.8,0,0,1,53.4,163.11V142.991a2.8,2.8,0,0,1,2.791-2.791H87.51a2.8,2.8,0,0,1,2.791,2.791V163.11a2.753,2.753,0,0,1-2.757,2.791Z",
    transform: "translate(-53.4 -140.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106135",
    "data-name": "Group 106135",
    transform: "translate(14.025 30.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69806",
    "data-name": "Path 69806",
    d: "M101.817,205.4a1.671,1.671,0,0,1-1.668-1.668V192.57H97.936v11.166a1.668,1.668,0,1,1-3.336,0V191.685a2.477,2.477,0,0,1,2.485-2.485H101a2.477,2.477,0,0,1,2.485,2.485v12.051a1.671,1.671,0,0,1-1.668,1.668Z",
    transform: "translate(-94.6 -189.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106136",
    "data-name": "Group 106136",
    transform: "translate(52.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69807",
    "data-name": "Path 69807",
    d: "M220.223,123.146a12.323,12.323,0,1,1,12.323-12.323A12.342,12.342,0,0,1,220.223,123.146Zm0-21.378a9.021,9.021,0,1,0,9.021,9.021A9.037,9.037,0,0,0,220.223,101.768Z",
    transform: "translate(-207.9 -98.5)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_106146",
    "data-name": "Group 106146",
    transform: "translate(100.866 30.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106139",
    "data-name": "Group 106139",
    transform: "translate(0.034 60.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69809",
    "data-name": "Path 69809",
    d: "M381.212,368.636H339.068a1.668,1.668,0,0,1,0-3.336h42.144a1.668,1.668,0,1,1,0,3.336Z",
    transform: "translate(-337.4 -365.3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106140",
    "data-name": "Group 106140",
    transform: "translate(0 16.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69810",
    "data-name": "Path 69810",
    d: "M377.5,288.624H342.611c-.136,0-.272-.034-.408-.034a5.308,5.308,0,0,1-4.9-5.277v-43.4a5.317,5.317,0,0,1,5.311-5.311H377.5a5.317,5.317,0,0,1,5.311,5.311v43.4A5.317,5.317,0,0,1,377.5,288.624Zm-34.553-3.336h34.587a1.976,1.976,0,0,0,1.974-1.974v-43.4a1.976,1.976,0,0,0-1.974-1.974H342.611a1.976,1.976,0,0,0-1.974,1.974v43.4a1.976,1.976,0,0,0,1.974,1.974A.577.577,0,0,1,342.951,285.288Z",
    transform: "translate(-337.3 -234.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106141",
    "data-name": "Group 106141",
    transform: "translate(28.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69811",
    "data-name": "Path 69811",
    d: "M425.585,206.242a1.671,1.671,0,0,1-1.668-1.668v-13.31a1.308,1.308,0,0,0-1.328-1.328h-1.021a1.668,1.668,0,0,1,0-3.336h1.021a4.634,4.634,0,0,1,4.63,4.63v13.31A1.61,1.61,0,0,1,425.585,206.242Z",
    transform: "translate(-419.9 -186.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106142",
    "data-name": "Group 106142",
    transform: "translate(10.042 0.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69812",
    "data-name": "Path 69812",
    d: "M368.468,206.508a1.671,1.671,0,0,1-1.668-1.668V191.53a4.634,4.634,0,0,1,4.63-4.63h1.021a1.668,1.668,0,1,1,0,3.336H371.43a1.308,1.308,0,0,0-1.328,1.328v13.31a1.613,1.613,0,0,1-1.634,1.634Z",
    transform: "translate(-366.8 -186.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106143",
    "data-name": "Group 106143",
    transform: "translate(0.034 22.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69813",
    "data-name": "Path 69813",
    d: "M381.212,256.036H339.068a1.668,1.668,0,0,1,0-3.336h42.144a1.668,1.668,0,1,1,0,3.336Z",
    transform: "translate(-337.4 -252.7)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_106147",
    "data-name": "Group 106147",
    transform: "translate(104.747 97.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69816",
    "data-name": "Path 69816",
    d: "M353.636,393.649a4.94,4.94,0,0,1-4.936-4.936v-3.745a1.668,1.668,0,0,1,3.336,0v3.745a1.6,1.6,0,1,0,3.2,0v-3.745a1.668,1.668,0,0,1,3.336,0v3.745A4.918,4.918,0,0,1,353.636,393.649Z",
    transform: "translate(-348.7 -383.3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106148",
    "data-name": "Group 106148",
    transform: "translate(132.662 97.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69817",
    "data-name": "Path 69817",
    d: "M435.636,393.649a4.94,4.94,0,0,1-4.936-4.936v-3.745a1.668,1.668,0,0,1,3.336,0v3.745a1.6,1.6,0,1,0,3.2,0v-3.745a1.668,1.668,0,0,1,3.336,0v3.745A4.94,4.94,0,0,1,435.636,393.649Z",
    transform: "translate(-430.7 -383.3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106149",
    "data-name": "Group 106149",
    transform: "translate(114.926 27.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69818",
    "data-name": "Path 69818",
    d: "M391.434,187.323h-8.272a4.562,4.562,0,1,1,0-9.123h8.306a4.562,4.562,0,0,1,4.562,4.562v.034A4.606,4.606,0,0,1,391.434,187.323Zm-8.272-5.787a1.226,1.226,0,1,0,0,2.451h8.306a1.25,1.25,0,0,0,1.226-1.26,1.22,1.22,0,0,0-1.226-1.226Z",
    transform: "translate(-378.6 -178.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106150",
    "data-name": "Group 106150",
    transform: "translate(24.663 69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69819",
    "data-name": "Path 69819",
    d: "M367.153,118.673a1.428,1.428,0,0,1-.817-.238,1.717,1.717,0,0,1-.851-1.464V113.7H339.068a1.671,1.671,0,0,1-1.668-1.668v-7.183a1.671,1.671,0,0,1,1.668-1.668h26.417V99.95a1.717,1.717,0,0,1,.851-1.464A1.629,1.629,0,0,1,368,98.52l14.059,8.545a1.639,1.639,0,0,1,.783,1.43,1.717,1.717,0,0,1-.783,1.43L368,118.435a1.882,1.882,0,0,1-.851.238ZM340.7,110.435h26.417a1.671,1.671,0,0,1,1.668,1.668v1.974l9.191-5.583-9.191-5.583v1.974a1.671,1.671,0,0,1-1.668,1.668H340.7Z",
    transform: "translate(-337.4 -98.273)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckout);
export default __webpack_public_path__ + "static/media/checkout.ea8b2e700630254ea345d0653853f927.svg";
export { ForwardRef as ReactComponent };